import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../services/api";
import ReportCard from "../components/ReportCard";
import { slugify } from "../utils/slugify";
import Dashboard from "../components/Dashboard";



export default function ReportsPage({ fallbackToFirstReport = false }) {
  const { department, report } = useParams();
  const [selectedReport, setSelectedReport] = useState(null);

  useEffect(() => {
    async function fetchReports() {
      try {
        const res = await axios.get("/authorized-reports/user");
        const grouped = res.data;

        const deptKey = Object.keys(grouped).find(
          (key) => slugify(key) === slugify(department)
        );
        if (!deptKey) return setSelectedReport(null);

        const found = grouped[deptKey].find(
          (r) => slugify(r.title) === slugify(report)
        );

        if (found) {
          setSelectedReport(found);
        } else if (fallbackToFirstReport && grouped[deptKey].length > 0) {
          setSelectedReport(grouped[deptKey][0]);
        } else {
          setSelectedReport(null);
        }
      } catch (err) {
        console.error("Error fetching reports:", err);
        setSelectedReport(null);
      }
    }

    fetchReports();
  }, [department, report, fallbackToFirstReport]);

  return (
    <div className="h-[calc(100vh-64px)] w-full overflow-hidden">
      {selectedReport ? (
        <ReportCard
          title={selectedReport.title}
          embedUrl={selectedReport.embed_url}
          fullscreen
        />
      ) : (
        <div className="text-center text-gray-500 pt-20">
          <Dashboard />
        </div>
      )}
    </div>
  );
}
